import fetch from 'utils/fetch';
import { error } from 'plugins/toastr';
import { hideLoader } from 'plugins/loader';

export const REQUEST_COMPANIES = 'REQUEST_COMPANIES';
export const RECEIVE_COMPANIES = 'RECEIVE_COMPANIES';
export const OPEN_MODAL = 'companies.OPEN_MODAL';
export const CLOSE_MODAL = 'companies.CLOSE_MODAL';

function requestCompanies(companies) {
  return {
    type: REQUEST_COMPANIES,
    payload: {
      companies,
    },
  };
}

export function receiveCompanies(companies) {
  return {
    type: RECEIVE_COMPANIES,
    payload: {
      companies,
    },
  };
}

function fetchCompanies(companies) {
  return dispatch => {
    dispatch(requestCompanies(companies));
    fetch(`/admin/companies.json`)
      .then(r => r.json())
      .then(nodes => dispatch(receiveCompanies(nodes)));
  };
}

function shouldFetchCompanies(state) {
  const companies = state.users.companies;
  if (companies.size === 0) {
    return true;
  } else if (companies.isFetching) {
    return false;
  }

  return companies.didInvalidate;
}

export function fetchCompaniesIfNeeded(companies) {
  return (dispatch, getState) => {
    if (shouldFetchCompanies(getState())) {
      dispatch(fetchCompanies(companies));
    }
  };
}

export const openModal = () => (dispatch, getState) => {
  dispatch({
    type: OPEN_MODAL,
  });
};

export const closeModal = () => (dispatch, getState) => {
  dispatch({
    type: CLOSE_MODAL,
  });
};

export const createCompany = data => (dispatch, getState) => {
  fetch('/admin/companies.json', {
    method: 'POST',
    body: data,
  })
    .then(res => res.json())
    .then(
      res => {
        closeModal()(dispatch, getState);
        dispatch(receiveCompanies(res));
      },
      err => {
        console.log('Error attempting to save company', err);
        hideLoader();
        error('Une erreur est survenue pendant la création de la société');
      }
    );
};



// WEBPACK FOOTER //
// ./src/modules/admin/actions/user.js